import { TopNav } from "@dashboard/components/AppLayout";
import SearchInput from "@dashboard/components/AppLayout/ListFilters/components/SearchInput";
import { DashboardCard } from "@dashboard/components/Card";
import { sectionNames } from "@dashboard/intl";
import { PageListProps, SearchPageProps, SortPage } from "@dashboard/types";
import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { paymentRecoveryMessages } from "../../messages";
import { CheckoutListUrlSortField } from "../../urls";
import { PaymentRecoveryCheckout } from "../../utils";
import { PaymentRecoveryListDatagrid } from "../PaymentRecoveryListDatagrid";

export interface PaymentRecoveryListPageProps
  extends PageListProps,
    SearchPageProps,
    SortPage<CheckoutListUrlSortField> {
  checkouts: PaymentRecoveryCheckout[];
  onRowClick?: (id: string) => void;
}

export const PaymentRecoveryListPage = ({
  checkouts,
  initialSearch,
  onSearchChange,
  ...listProps
}: PaymentRecoveryListPageProps) => {
  const intl = useIntl();

  return (
    <>
      <TopNav
        title={intl.formatMessage(sectionNames.paymentRecovery)}
        withoutBorder
        isAlignToRight={false}
      >
        <Box __flex={1} display="flex" justifyContent="flex-end" alignItems="center">
          <Text size={2} color="default2">
            {intl.formatMessage(paymentRecoveryMessages.pageSubtitle)}
          </Text>
        </Box>
      </TopNav>

      <DashboardCard>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" gap={4} paddingBottom={2} paddingX={6}>
            <Box __flex={1}>
              <SearchInput
                initialSearch={initialSearch}
                placeholder={intl.formatMessage(paymentRecoveryMessages.searchPlaceholder)}
                onSearchChange={onSearchChange}
              />
            </Box>
          </Box>
        </Box>

        <PaymentRecoveryListDatagrid
          checkouts={checkouts}
          hasSearch={!!initialSearch}
          {...listProps}
        />
      </DashboardCard>
    </>
  );
};

PaymentRecoveryListPage.displayName = "PaymentRecoveryListPage";
export default PaymentRecoveryListPage;
